import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ThemeProvider, createTheme, CssBaseline, Box } from "@mui/material";
import { LandingLayout } from "@coremind/site-template-landing";
const wwwTheme = createTheme({
    palette: {
        mode: "dark",
        background: { default: "#0a0d14", paper: "#10141f" },
        primary: { main: "#6366f1", light: "#818cf8", dark: "#4f46e5", contrastText: "#fff" },
        secondary: { main: "#06b6d4" },
        divider: "rgba(255,255,255,0.07)",
        text: { primary: "#f1f5f9", secondary: "#94a3b8" },
    },
    typography: { fontFamily: '"Inter","Helvetica Neue",Arial,sans-serif' },
    shape: { borderRadius: 10 },
    components: {
        MuiCard: { styleOverrides: { root: { background: "#10141f", border: "1px solid rgba(255,255,255,0.07)" } } },
        MuiPaper: { styleOverrides: { outlined: { borderColor: "rgba(255,255,255,0.07)" } } },
    },
});
const NAV_ITEMS = [
    { label: "Sites", href: "/#sites" },
    { label: "Pricing", href: "/#pricing" },
    { label: "Docs", href: "https://docs.offsetmind.com", external: true },
    { label: "Status", href: "https://status.offsetmind.com", external: true },
];
const Logo = (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Box, { sx: { width: 26, height: 26, borderRadius: "7px", background: "linear-gradient(135deg,#6366f1,#06b6d4)", flexShrink: 0 } }), _jsx(Box, { sx: { fontWeight: 700, fontSize: 17, letterSpacing: "-0.3px", color: "text.primary" }, children: "Offsetmind" })] }));
export default function WwwLayout({ children }) {
    return (_jsxs(ThemeProvider, { theme: wwwTheme, children: [_jsx(CssBaseline, {}), _jsx(LandingLayout, { navItems: NAV_ITEMS, slots: { logo: Logo }, children: children })] }));
}
